import { Link } from "react-router";
import Icon from "../../../../../design-system/components/Icon/Icon.jsx";
import { styles } from "./StepNavigation.css.ts";

/**
 * StepNavigation component handles the navigation between different steps of a module of a chapter of a Spark.
 *
 * @param {Object} props - The properties for the component.
 * @param {Object} props.step - The current step information.
 * @param {Object|null} props.prevStep - The information for the previous step, or null if there is none.
 * @param {Object|null} props.nextStep - The information for the next step, or null if there is none.
 * @param {Array} props.stationSteps - Array of steps for the stepper.
 */
export const StepNavigation = ({
  step,
  prevStep,
  nextStep,
  stationSteps,
  disableSome = false,
}) => {
  const withStepper = stationSteps && stationSteps.length > 1;
  function getStepState(otherStep) {
    if (disableSome && otherStep.disabled) return "DISABLED";
    if (step.key === otherStep.key) {
      return "ACTIVE";
    } else {
      return "INACTIVE";
    }
  }
  return (
    <nav
      className={styles.stepNavigation}
      aria-label="Etappenschrittnavigation"
      id="step-navigation"
    >
      <Link
        to={prevStep ? `../step/${prevStep.slug}` : ".."}
        aria-label={
          prevStep ? "zurück zum vorherigen Schritt" : "Zurück zur Übersicht"
        }
      >
        <Icon name="arrowleft" />
      </Link>
      {withStepper && (
        <div className={styles.stepper} aria-hidden="true">
          {stationSteps.map((s) => (
            <Link
              key={s.key}
              to={`../step/${s.slug}`}
              className={styles.stepButton({
                state: getStepState(s, disableSome),
              })}
            />
          ))}
        </div>
      )}
      <Link
        to={nextStep ? `../step/${nextStep.slug}` : ".."}
        aria-label={
          nextStep ? "weiter zum nächsten Schritt" : "Zurück zur Übersicht"
        }
      >
        <Icon name="arrowright" />
      </Link>
    </nav>
  );
};
